// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36zT5","col":"styles_col__3cMPW","actions":"styles_actions__3crGS","conflict":"styles_conflict__60jbz"};